import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Styles } from '../../../css/table';
import { TablePagination } from '../../common/table/tablePagination';
import { spinTheWheelConfigColumn } from '../../common/table/TableColumns/spinTheWheelConfig';

const SpinTheWheelTable = ({ pageCount, fetchData }) => {
  const { spinTheWheelConfigs } = useSelector(state => state.gameConfig);

  return (
    <div className="w-full h-full">
      <Styles>
        <TablePagination
          columns={spinTheWheelConfigColumn}
          data={spinTheWheelConfigs?.data || []}
          total_item={spinTheWheelConfigs?.total_items}
          fetchData={fetchData}
          pageCount={pageCount}
          className="rounded"
        />
      </Styles>
    </div>
  );
};
SpinTheWheelTable.propTypes = {
  fetchData: PropTypes.func,
  pageCount: PropTypes.number,
};
export default SpinTheWheelTable;
